if (!customElements.get('md-cart-recommendation')) {
  customElements.define('md-cart-recommendation', class extends HTMLElement {
    connectedCallback() {
      if (this.mdReady) return;
      this.mdReady = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('select[name="id"]')) return;
        const option = event.target.selectedOptions[0];
        if (!option) return;
        this.querySelector('[data-md-price]').textContent = option.dataset.price;
        const old = this.querySelector('[data-md-old]');
        old.textContent = option.dataset.old;
        old.hidden = !option.dataset.old;
        const image = this.querySelector('.md-rec-image img');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.imageAlt || '';
        }
      });
    }
  });
}
